module.exports = __webpack_public_path__ + "img/CK.420c555e.svg";